import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { BootstrapModule } from '../bootstrap.module';
import { RouterModule } from '@angular/router';
import { DashreportService } from './dashreport.service';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { ModuleWithProviders } from '@angular/compiler/src/core';
import { HttpClientModule } from '@angular/common/http';
import { MatFormFieldModule, MatAutocompleteModule, MatInputModule, MatDatepickerModule } from '@angular/material';
import { DashreportListComponent } from './list/list.component';

import { TooltipModule } from 'ngx-bootstrap';
import { NgxLoadingModule } from 'ngx-loading';

@NgModule({
  imports: [
    CommonModule,
    BootstrapModule,
    RouterModule,
    ReactiveFormsModule,
    FormsModule,
    HttpClientModule,
    MatFormFieldModule,
    MatAutocompleteModule,
    MatDatepickerModule,
    MatInputModule,
    TooltipModule.forRoot(),
    NgxLoadingModule.forRoot({})
  ],
  declarations: [
    DashreportListComponent,
    // KeysPipe,
  ],
  exports: [
  ]
})
export class DashreportModule {
  static forRoot(): ModuleWithProviders {
    return {
      ngModule: DashreportModule,
      providers: [
        DashreportService,
      ]
    };
  }
}



// WEBPACK FOOTER //
// ./src/app/modules/dashreport/dashreport.module.ts